export type GhostType
    = 'Banshee'
    | 'Demon'
    | 'Deogen'
    | 'Goryo'
    | 'Hantu'
    | 'Jinn'
    | 'Mare'
    | 'Mimic'
    | 'Moroi'
    | 'Myling'
    | 'Obake'
    | 'Oni'
    | 'Onryo'
    | 'Phantom'
    | 'Poltergeist'
    | 'Raiju'
    | 'Revenant'
    | 'Shade'
    | 'Spirit'
    | 'Thaye'
    | 'Twins'
    | 'Wraith'
    | 'Yokai'
    | 'Yurei'
    | 'Obambo'
    | 'Dayan'
    | 'Gallu';

export const ALL_GHOST_TYPES: Array<GhostType> = [
    'Banshee',
    'Demon',
    'Hantu',
    'Moroi',
    'Obambo',
    'Phantom',
    'Revenant',
    'Thaye',
    'Wraith',

    'Dayan',
    'Gallu',
    'Jinn',
    'Myling',
    'Oni',
    'Poltergeist',
    'Shade',
    'Mimic',
    'Yokai',

    'Deogen',
    'Goryo',
    'Mare',
    'Obake',
    'Onryo',
    'Raiju',
    'Spirit',
    'Twins',
    'Yurei',
];

export interface Ghost {
    type: GhostType;
    status: boolean | undefined;
}
